import { styled } from "styled-components";

const CategoryHeader = styled.div`
  font-family: Inter;
  font-weight: bold;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ArrowIcon = styled.img`
  transition: transform 0.2s ease-in-out;
  transform: ${props => props.isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)'};
  margin-left: ${props => props.marginLeft || '0'};
`;

const SelectDropdownWrapper = styled.button`
    display: flex;
    width: ${props => props.width || '100%'};
    height: 32px;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    padding: 9px 16px;
    border: 1px solid ${props => props.theme.colors.clearGray};
    background-color: ${props => props.theme.colors.primaryWhite};
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: ${props => props.theme.colors.darkGray};
    cursor: pointer;
    position: relative;
    margin-bottom: 9px;
    text-align: left;
    outline: none;

    &:focus {
        border-color: ${props => props.theme.colors.darkGray};
    }
`;

const DropdownContainer = styled.div`
    position: relative;
    width: 100%;
`;

const DropdownLabel = styled.div`
    font-family: Inter;
`;

const ItemsContainer = styled.div`
    position: fixed;
    top: ${props => props.top}px;
    right: ${props => props.right}px;
    width: ${props => props.width};
    height: ${props => props.height || 'auto'};
    box-shadow: 0px 4px 4px 0px #00000040;
    background-color: ${props => props.theme.colors.highClearGray};
    padding: 16px;
    max-height: 450px;
    border-radius: 8px;
    z-index: 1000;
    transform: translateX(calc(100% - ${props => props.width}));
    display: flex;
    flex-direction: column;
`;

const SearchContainer = styled.div`
    margin-bottom: 8px;
    flex-shrink: 0;
`;

const CustomSearchInput = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 6px 16px;
    gap: 8px;
    border-radius: 8px;
    background-color: ${props => props.theme.colors.primaryWhite};
    border: 1px solid ${props => props.theme.colors.clearGray};
`;

const SearchIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
`;

const SearchInput = styled.input`
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    font-family: Inter;
    font-size: 14px;
    line-height: 19px;
    color: ${props => props.theme.colors.darkGray};
    background: transparent;

    &::placeholder {
        color: ${props => props.theme.colors.clearGray};
    }
`;

const Items = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${props => props.theme.colors.clearGray};
    border-radius: 8px;
    background-color: white;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
`;

const Item = styled.div`
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: ${props => props.theme.colors.darkGray};
    width: 100%;
    padding-inline: 16px;
    padding-block: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${props => props.theme.colors.clearGray};
    }
`;

const GroupedItems = styled.div`
    display: flex;
    flex-direction: column;
`;

const UngroupedItems = styled.div`
    display: flex;
    flex-direction: column;
`;

export {
    CategoryHeader,
    SelectDropdownWrapper,
    ItemsContainer,
    Items,
    Item,
    SearchContainer,
    CustomSearchInput,
    SearchIcon,
    SearchInput,
    ArrowIcon,
    GroupedItems,
    UngroupedItems,
    DropdownContainer,
    DropdownLabel
}